<script lang="ts">
	import { Carousel } from '@core/builders/carousel/Carousel.svelte';
	import type { ContentQuoteList } from './QuoteListQuery';
	import { SnapAlign } from '@core/builders/carousel/modifiers/Snap';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';

	let { data, theme = 'dark' }: { data: ContentQuoteList; theme?: string } = $props();

	const carousel = Carousel.from(data.items, {
		drag: true,
		snap: { align: SnapAlign.START },
		scroll: {
			mode: 'interval',
			auto: -8 // 8 seconds when mode is interval (negative value determins the direction)
		},
		setHeightToTallestItem: true
	});
	carousel.state.gap = 60;

	createViewController();
</script>

<div class="container theme-{theme}" use:ViewController>
	<h3 class="text:description-small" use:EnterOnView>
		<span class="dot theme-{theme} eyebrow"></span>{data.eyebrow}
	</h3>

	<div class="quotes" use:carousel.useContainer {...carousel.attr.container}>
		{#each carousel.items as item}
			<div class="item" use:item.useItem {...item.attr}>
				<p class="quote text:description-large" use:EnterOnView={{ delay: 0.15 }}>
					"{item.data.text}"
				</p>
				<p class="author text:description-small" use:EnterOnView={{ delay: 0.3 }}>
					{item.data.name}
				</p>
			</div>
		{/each}
	</div>
</div>
<div class="marks">
	{#each carousel.items as item}
		<div class="dot theme-{theme}" data-active={carousel.state.index === item.index}></div>
	{/each}
</div>

<style lang="scss">
	.container {
		display: flex;
		justify-content: space-between;
		width: 100%;
		gap: 40px;
		flex-direction: column;

		@include md {
			gap: 20px;
		}
	}
	.author {
		margin-top: 40px;
	}

	.marks {
		position: absolute;
		right: 40px;
		bottom: 40px;
		padding-top: 40px;
		background-color: hsl(var(--color-foreground));

		@include md {
			right: 50px;
			bottom: 50px;
		}

		&.theme-light {
			background-color: hsl(var(--color-background));
		}

		.dot {
			opacity: 0.3;
			margin-left: 7px;

			&[data-active='true'] {
				opacity: 1;
			}
		}
	}

	.item {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding-right: 50px;
		min-height: 250px;
	}

	.quotes {
		display: flex;
		overflow: hidden;
		width: 100%;
		height: 100%;
	}

	.eyebrow {
		margin-right: 20px;
	}

	.dot {
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background-color: hsl(var(--color-primary));

		&.theme-light {
			background-color: hsl(var(--color-foreground));
		}
	}
</style>
